import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid';
import { listPartners } from '../../../../modules/partnerModule/partners';
import ParnterList from '../../../../components/common/form/modal/ParnterList';
import { PartnerListBox } from '../../../../components/common/form/modal/ParnterListBox';

import { useFormik } from 'formik';
import * as yup from 'yup';

const PartnerListContainer = ({ link, handleClose, selectedPartner }) => {
    const dispatch = useDispatch();
    const [searchPartnerTyp, setSearchPartnerTyp] = useState("");
    const [searchTradeTyp, setSearchTradeTyp] = useState(['매출처','매입처']);
    const [searchKeyword, setSearchKeyword] = useState("partnerNm");
    const [searchWords, setsearchWords] = useState(null);

    const searchList = (values) => {

        let searchData = {
            [values.searchKeyword]: values.searchWords
        };
    // // 배열이 비어 있지 않을 때만 partnerTyp 필터 추가
    //     if (Array.isArray(values.searchTradeTyp) && values.searchTradeTyp.length > 0) {
    //         searchData.tradeTypList = values.searchTradeTyp;
    //     }
  
        if (values.searchPartnerTyp !== null && values.searchPartnerTyp !== '') {
            searchData.partnerTyp = values.searchPartnerTyp;
        }

        dispatch(listPartners(searchData));
        setSearchTradeTyp(values.searchTradeTyp);  // ← 이름 통일
        setSearchPartnerTyp(values.searchPartnerTyp);
        setSearchKeyword(values.searchKeyword);
        setsearchWords(values.searchWords);

    }

    const handleRowClick = (data) => {
        selectedPartner(data.row);
        //formik.resetForm();
        setSearchKeyword('partnerNm');
        setsearchWords('');
        setSearchPartnerTyp('');
        dispatch(listPartners());
        handleClose();
    }


    //searchForm
    const initialValues = {
        searchTradeTyp: searchTradeTyp,
        searchPartnerTyp: searchPartnerTyp,
        searchKeyword: searchKeyword,
        searchWords: searchWords,
    };


    const validationSchema = yup.object({
        searchKeyword: yup.string('').nullable(),
        searchWords: yup.string('').trim().nullable(),

    });

    const { partners, error, loading } = useSelector(
        ({ partnerModule, loading }) => ({
            partners: partnerModule.partners.partners,
            error: partnerModule.partners.error,
            loading: loading['partner/LIST_PARTNERS'],
        }),
    );

    useEffect(() => {
       searchList(initialValues);
        //dispatch(listPartners(searchList(initialValues)));
    }, []);

    const apiRef = useGridApiRef();


    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'partnerUuid',
                headerName: '회사코드',
                hide: true,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'partnerTyp',
                headerName: '거래처 종류',
                minWidth: 100,
                flex: 1,
                editable: false,
                align: 'center',
                headerAlign: 'center',

            },
            {
                field: 'partnerNm',
                headerName: '회사명',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'regNumber',
                headerName: '사업자번호',
                minWidth: 130,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'center',
                headerAlign: 'center',
            },
            {
                field: 'partnerPhone',
                headerName: '연락처',
                minWidth: 130,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'partnerAddr',
                headerName: '주소',
                minWidth: 250,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'partnerDesc',
                headerName: '비고',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },


        ],
        [],
    );



    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            searchList(values);
            setSubmitting(false);
        },
    });

    return (
        <div>
            <PartnerListBox link={link} formik={formik} />
            <ParnterList
                apiRef={apiRef}
                columns={columns}
                rows={partners}
                error={error}
                loading={loading}
                handleRowClick={handleRowClick}

                columnVisibilityModel={{
                    id: false,
                    partnerUuid: false,
                }}    
            />
        </div>
    )
}

export default PartnerListContainer